<template>
	<div class="construction-body-div col-12 banCopy">
		<ul class="construction-list list-unstyled col-8">
			<li class="construction-list-item mouseLink" v-for="item in listArr" :key="item"
				@click="gotoEssay(item.title, item.content, item.author)">
				<div class="construction-item-box">
					<div class="construction-img-box">
						<img class="construction-img" :src="item.img_url" />
					</div>
					<div class="construction-item-title-box">
						<h5 class="construction-item-title">{{ item.title }}</h5>
						<h6 class="construction-item-timeBox">
							<span class="construction-item-timeBox-yearText">
								{{ item.year }}
							</span>
							<span class="construction-item-timeBox-dayText">
								{{ item.day }}
							</span>
						</h6>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				listArr: [{
						content: "<p><img src=\"https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/jpeg/ABWXZMNHK0123568_1594111197.jpg\" title=\"ABWXZMNHK0123568_1594111197.jpg\" _src=\"https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/jpeg/ABWXZMNHK0123568_1594111197.jpg\" alt=\"党建.jpg\" width=\"916\" height=\"595\" style=\"width: 916px; height: 595px;\"/></p>",
						create_time: "2020年01月07日",
						img_url: "https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/jpeg/ABWZMTHK01346789_1594110919.jpg",
						title: "党建工作",
						year:"2020年",
						day:"01月07日"
					},
					{
						content: "<p><img src=\"https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/jpeg/ABWXZMNHK0123568_1594111197.jpg\" title=\"ABWXZMNHK0123568_1594111197.jpg\" _src=\"https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/jpeg/ABWXZMNHK0123568_1594111197.jpg\" alt=\"党建.jpg\" width=\"916\" height=\"595\" style=\"width: 916px; height: 595px;\"/></p>",
						create_time: "2020年01月07日",
						img_url: "https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/jpeg/ABWZMTHK01346789_1594110919.jpg",
						title: "党建工作",
						year:"2020年",
						day:"01月07日"
					},
					{
						content: "<p><img src=\"https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/jpeg/ABWXZMNHK0123568_1594111197.jpg\" title=\"ABWXZMNHK0123568_1594111197.jpg\" _src=\"https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/jpeg/ABWXZMNHK0123568_1594111197.jpg\" alt=\"党建.jpg\" width=\"916\" height=\"595\" style=\"width: 916px; height: 595px;\"/></p>",
						create_time: "2020年01月07日",
						img_url: "https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/jpeg/ABWZMTHK01346789_1594110919.jpg",
						title: "党建工作",
						year:"2020年",
						day:"01月07日"
					},
					{
						content: "<p><img src=\"https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/jpeg/ABWXZMNHK0123568_1594111197.jpg\" title=\"ABWXZMNHK0123568_1594111197.jpg\" _src=\"https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/jpeg/ABWXZMNHK0123568_1594111197.jpg\" alt=\"党建.jpg\" width=\"916\" height=\"595\" style=\"width: 916px; height: 595px;\"/></p>",
						create_time: "2020年01月07日",
						img_url: "https://czw-netmi.oss-cn-hangzhou.aliyuncs.com/__liemi__/image/jpeg/ABWZMTHK01346789_1594110919.jpg",
						title: "党建工作",
						year:"2020年",
						day:"01月07日"
					}
				],
			};
		},
		mounted() {
			//this.Post();
		},
		methods: {
			gotoEssay(title, content, author) {
				this.$router.push({
					name: "essay",
					query: {
						title: title,
						content: content,
						author: author,
						type: "construction",
					},
				});
			},
			Post() {
				var url = "http://demoapi.hkjt.cn/pages/corporateCulture.php?type=1";

				this.axios
					.get(url)
					.then((res) => {
						this.listArr = res.data;
						console.log(this.listArr)
					})
					.catch((e) => {
						if (e.response) {
							//请求已发出，服务器返回状态码不是2xx。
							console.info(e.response.data);
							console.info(e.response.status);
							console.info(e.response.headers);
						} else if (e.request) {
							// 请求已发出，但没有收到响应
							// e.request 在浏览器里是一个XMLHttpRequest实例，
							// 在node中是一个http.ClientRequest实例
							console.info(e.request);
						} else {
							//发送请求时异常，捕捉到错误
							console.info("error", e.message);
						}
						console.info(e.config);
					});
			},
		},
	};
</script>

<style scoped>
	.construction-list{
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
		grid-column-gap: 5rem;
		grid-row-gap: 5rem;
		padding: 0 3rem;
		transition: 0.3s;
		margin-bottom: 3.6rem;
	}
	
	.construction-list-item{
		width: 21rem;
		box-shadow: 0 0.4375rem 1.875rem rgba(52, 47, 62, .3);
		border-radius: 5px;
		overflow: hidden;
		transition: 0.3s;
		user-select: none;
		margin-bottom: 0;
	}
	
	.construction-item-timeBox {
		background-color: rgba(35,127,239,0.2);
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: 3rem;
		padding: 0 1rem;
		position: absolute;
		/* top: 3.2rem; */
		bottom: -10px;
		left: 1.05rem;
	}
	
	.construction-item-timeBox>span{
		width: 70px;
		/* width: 100%; */
		display: flex;
		justify-content: space-between;
	}
</style>